import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=f835758c&scoped=true"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"
import style0 from "./LandingView.vue?vue&type=style&index=0&id=f835758c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f835758c",
  null
  
)

export default component.exports